module.exports = __webpack_public_path__ + "components/patterns/cardCollectionObject/result-placeholder.png";